import {Directive, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, Renderer2} from '@angular/core';
import {concat, interval, of, Subject, Subscription} from 'rxjs';
import {map, takeUntil} from 'rxjs/operators';

@Directive({
    selector: '[mzTimer]',
})
export class TimerDirective implements OnInit, OnDestroy {
    @Input() mzTimer;
    @Input() startedAt: string;
    @Input() now: string;
    @Output() dinDon = new EventEmitter();
    time = {hours: 0, minutes: 0, seconds: 59};
    time$: Subscription;
    stop$ = new Subject();

    constructor(private el: ElementRef,
                private rdr: Renderer2) {
    }

    ngOnInit(): void {
        this.checkStarted();
        this.timerConstructor();
    }

    timerConstructor() {

        if (this.mzTimer < 1) {
            this.time.hours = 0;
            this.time.minutes = 0;
            this.time.seconds = 0;
            this.el.nativeElement.innerHTML = `-- : -- : --`;
            return;
        }
        if (this.mzTimer > 60) {
            this.time.hours = Math.floor(this.mzTimer / 60);
            this.time.minutes = this.mzTimer - this.time.hours * 60;
        } else {
            this.time.hours = 0;
            this.time.minutes = this.mzTimer - 1;
        }
        this.runTimer();
    }

    runTimer() {

        this.time$ = concat(
            of(this.getTimeString()), interval(1000)
                .pipe(takeUntil(this.stop$), map((e) => {
                    const hour = this.time.hours;
                    const min = this.time.minutes;
                    const sec = this.time.seconds;
                    if (min === 0 && sec === 0 && hour === 0) {
                        this.time.seconds = 0;
                        this.stop$.next(true);
                        this.dinDon.emit();
                    }
                    if (min === 0 && sec < 60 && hour === 0) {
                        this.rdr.setStyle(this.el.nativeElement, 'color', 'red');
                    }
                    if (min === 0 && sec === 0) {
                        this.time.minutes = 59;
                        this.time.hours--;
                    }
                    if (sec === 0) {
                        if (min !== 0) {
                            this.time.minutes--;
                        }
                        this.time.seconds = 60.;

                    }
                    this.time.seconds--;
                    if (!this.startedAt) {
                        localStorage.setItem('duration', JSON.stringify(this.time));
                    }
                    return this.getTimeString();
                })))
            .subscribe(t => this.el.nativeElement.innerHTML = t);
    }

    getTimeString() {
        const s = this.time.seconds > 9 ? this.time.seconds.toString() : ('0' + +this.time.seconds);
        const m = this.time.minutes > 9 ? this.time.minutes.toString() : ('0' + +this.time.minutes);
        const h = this.time.hours > 9 ? this.time.hours.toString() : ('0' + +this.time.hours);
        return `${h} : ${m} : ${s}`;
    }

    ngOnDestroy() {
        localStorage.removeItem('duration');

        this.stop$.next(true);
    }

    private checkStarted() {
        const lsDuration = localStorage.getItem('duration');
        if (lsDuration) {
            this.time = JSON.parse(lsDuration);
        }

        if (this.startedAt) {
            const now = +new Date(this.now);
            const started = +new Date(this.startedAt);
            const diff = now - started;
            const diffMin = Math.floor(diff / 60000);
            const seconds = ((diff % 60000) / 1000).toFixed(0);
            this.time.seconds -= +seconds;
            if (diffMin < 0) {
                this.mzTimer = 0;
            } else {
                this.mzTimer = diffMin >= 0 ? this.mzTimer - diffMin : 0;
            }
        }
    }
}
